export const HelivanColor = {
  background: {
    primary: '#FFFFFF',
    lightestGrey: '#F8F8F8',
    secondary: '#F6F7F9',
  },
  text: {
    black: '#1E1E1E',
    blueDark: '#114471',
    blueLight: '#e3ebfb',
    blueMid: '#486884',
    helivanBlue: '#00477D',
    gray: '#859198',
  },
  hover: {
    primary: '#EDEDED',
    blueDarker: '#182944',
    lightBlue: '#D6EDFF',
  },
  border: {
    primary: '#AFBEC6',
    hover: '#CDCDCD',
    blueDark: '#233b62',
  },
};
